











import { Vue } from 'vue-property-decorator'
import Component from 'vue-class-component'
import PhoneForm from '@/modules/login/components/PhoneForm.vue'
import FormCard from '@/modules/login/components/common/FormCard.vue'
import LoginStore from '@/modules/login/stores/LoginStore'
import ValidationErrors from '@/modules/login/components/common/ValidationErrors.vue'
import AuthorizationService from '@/modules/login/services/AuthorizationService'
import PasswordForm from '@/modules/login/components/PasswordForm.vue'
import AccessDenied from '@/modules/login/components/AccessDenied.vue'
import SmsForm from '@/modules/login/components/SmsForm.vue'
import QrForm from '@/modules/login/components/QrForm.vue'

@Component({
  components: {
    QrForm,
    SmsForm,
    AccessDenied,
    PasswordForm,
    ValidationErrors,
    FormCard,
    PhoneForm,
  },
})
export default class LoginPage extends Vue {
  get isShowPhoneForm(): boolean {
    return this.authMethod === null && !this.accessIsDenied
  }

  get isShowPasswordForm(): boolean {
    return this.authMethod
      ? this.authMethod.type === AuthorizationService.types.login
      : false
  }

  get isShowSmsForm(): boolean {
    return this.authMethod
      ? this.authMethod.type === AuthorizationService.types.sms
      : false
  }

  get isShowQrForm(): boolean {
    return this.authMethod
      ? this.authMethod.type === AuthorizationService.types.qr
      : false
  }

  get accessIsDenied(): boolean {
    return !!LoginStore.ipError
  }

  get errorMessage(): string {
    return LoginStore.errorMessage
  }

  get authMethod() {
    return LoginStore.authMethod
  }
}
